// Validacion de formato de alias y CBU/CVU de Mercado Pago, para detectar
// errores de tipeo del vendedor antes de guardarlos (no confirma que la
// cuenta exista ni que sea del vendedor, solo que el formato es correcto).

const checkBlock = (block, weights) => {
  const digits = block.slice(0, -1).split("").map(Number);
  const checkDigit = Number(block[block.length - 1]);
  const sum = digits.reduce((acc, d, i) => acc + d * weights[i], 0);
  return (10 - (sum % 10)) % 10 === checkDigit;
};

export const isValidCbu = (cbu) => {
  if (!/^\d{22}$/.test(cbu)) return false;
  return checkBlock(cbu.slice(0, 8), [7, 1, 3, 9, 7, 1, 3])
      && checkBlock(cbu.slice(8, 22), [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3]);
};

export const isValidAlias = (alias) => /^[a-z0-9.\-_]{6,20}$/.test(alias.toLowerCase());
